import CustomerRemark from '../../customer/models/CustomerRemark';

export const BROADCAST = {
  TIME_TYPE: {
    TWO_DAYS: 2,
    TODAY: 0,
  },
  INTERACT_TYPE: {
    NONE: -1,
    ALL: 0,
    TEXT: 1,
    IMAGE: 2,
    VOICE: 3,
    MENU: 4,
    SUBSCRIBE: 5,
    SCAN: 6,
    CHECK: 7,
    PAY: 8,
    MESSAGE: 100,
  },
  INTERACT_TYPE_ALL: {
    ON: 1,
    OFF: 0,
  },
  CONTENT_TYPE: {
    TEXT: 0,
    NEWS: 1,
    COUPON: 2,
    IMAGE: 3,
  },
  STATUS: {
    WAIT: 0,
    ING: 1,
    SUCCESS: 2,
    FAILURE: -1,
  },
};

export class Broadcast {
  public id: number;
  public weixinId: string;
  public timeType: number;
  public interactType: number;
  public interactTypeIsAll: number;
  public remarkSet?: CustomerRemark[];
  public contentType: number;
  public text?: string;
  public newsId?: number;
  public articles?: NewsItem;
  public couponId?: string;
  public cardId?: string;
  public couponText?: string;
  public expectCount: number;
  public sendCount?: number;
  public successCount?: number;
  public failureCount?: number;
  public status: number;
  public mediaId?: string;
  public imageId?: number;
  public imageUrl?: string;
  public startTime?: string;
  public endTime?: string;
  public gmtCreate?: string;
  public gmtModified?: string;
  public propConfigs?: any[];

  public constructor(b: Broadcast) {
    this.id = b.id;
    this.weixinId = b.weixinId;
    this.timeType = b.timeType;
    this.interactType = b.interactType;
    this.interactTypeIsAll = b.interactTypeIsAll;
    this.remarkSet = b.remarkSet;
    this.contentType = b.contentType;
    this.text = b.text;
    this.newsId = b.newsId;
    this.articles = b.articles;
    this.couponId = b.couponId;
    this.cardId = b.cardId;
    this.couponText = b.couponText;
    this.expectCount = b.expectCount;
    this.sendCount = b.sendCount;
    this.successCount = b.successCount;
    this.failureCount = b.failureCount;
    this.status = b.status;
    this.mediaId = b.mediaId;
    this.imageId = b.imageId;
    this.imageUrl = b.imageUrl;
    this.startTime = b.startTime;
    this.endTime = b.endTime;
    this.gmtCreate = b.gmtCreate;
    this.gmtModified = b.gmtModified;
  }
}

export class RemarkSet {
  public remarks: string[];
  public constructor(r: RemarkSet) {
    this.remarks = r.remarks;
  }
}

export class NewsItem {
  public title: string;
  public description?: string;
  public url: string;
  public picurl?: string;

  public constructor(n: NewsItem) {
    this.title = n.title;
    this.description = n.description;
    this.url = n.url;
    this.picurl = n.picurl;
  }
}

export const broadcast: Broadcast = {
  id: 0,
  weixinId: '',
  timeType: BROADCAST.TIME_TYPE.TWO_DAYS,
  interactType: BROADCAST.INTERACT_TYPE.NONE,
  interactTypeIsAll: BROADCAST.INTERACT_TYPE_ALL.OFF,
  contentType: BROADCAST.CONTENT_TYPE.TEXT,
  remarkSet: [],
  status: BROADCAST.STATUS.WAIT,
  expectCount: 0,
};
